type OSType = 'android' | 'ios' | 'computer';
type BrowserType = 'unknown' | 'Chrome' | 'Edge' | 'Firefox' | 'Safari' | 'Opera' | 'Internet Explorer';
export const detectDeviceType = (): { os: OSType; browser: BrowserType } => {
  const userAgent = navigator.userAgent;

  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/i.test(userAgent);

  let browser: BrowserType = 'unknown';
  if (/CriOS/i.test(userAgent)) {
    browser = 'Chrome';
  } else if (/Chrome/i.test(userAgent) && !/Edge|Edg|OPR|Opera/i.test(userAgent)) {
    browser = 'Chrome'; // Chrome on other platforms
  } else if (/Edg/i.test(userAgent)) {
    browser = 'Edge';
  } else if (/Firefox/i.test(userAgent)) {
    browser = 'Firefox';
  } else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent) && !/CriOS/i.test(userAgent)) {
    browser = 'Safari';
  } else if (/OPR|Opera/i.test(userAgent)) {
    browser = 'Opera';
  } else if (/MSIE|Trident/i.test(userAgent)) {
    browser = 'Internet Explorer';
  }

  if (isAndroid) {
    return {
      os: 'android',
      browser: browser
    };
  } else if (isIOS) {
    return {
      os: 'ios',
      browser: browser
    };
  } else {
    return {
      os: 'computer',
      browser: browser
    };
  }
};

export const isMobile = () => {
  if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
    return false;
  }
  return /Mobile|Android|iPhone|iPad|iPod|BrackBerry|Windows Phone/i.test(navigator.userAgent);
};
